import React, { useState } from "react";

import { useGetOptionQuery } from "@/redux/api/prQuery";
import { AllForOptions } from "@/schemas/GlobalSchema";

type TProjectRegisterContext = {
  leadsOptions: AllForOptions[];
  isShowMarkAsWonModal: boolean;
  setIsShownMarkAsWonModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const projectRegisterContext = React.createContext<TProjectRegisterContext>(
  {} as TProjectRegisterContext,
);

export const useProjectRegisterContext = (): TProjectRegisterContext => {
  return React.useContext(projectRegisterContext);
};

export const ProjectRegisterContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const [isShowMarkAsWonModal, setIsShownMarkAsWonModal] = useState(false);

  const { data: leadsOptions = [] } = useGetOptionQuery({
    filters: "",
  });

  return (
    <projectRegisterContext.Provider
      value={{
        leadsOptions: leadsOptions as unknown as AllForOptions[],
        isShowMarkAsWonModal,
        setIsShownMarkAsWonModal,
      }}
    >
      {children}
    </projectRegisterContext.Provider>
  );
};
